import React, { useState } from "react";
import ActionButton from "../../Components/Buttons/ActionButton";
import PropTypes from "prop-types";

const ModalToggleButton = (props) => {
    let [isModalOpen, setIsModalOpen] = useState(false);

    return (<>
        <div className="button-group margin-0 padding-0">
            <ActionButton
                icon={props.icon}
                title={props.title}
                className={props.className}
                onClick={(e) => {setIsModalOpen(true)}}
                isDisabled={props.isDisabled}
            />
        </div>

        {props.modalContent(isModalOpen, () => { setIsModalOpen(false) }) }
    </>)
}

ModalToggleButton.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    isDisabled: PropTypes.bool,
    className: PropTypes.string,
}

ModalToggleButton.defaultProps = {
    title: '',
    icon: null,
    isDisabled: false,
    className: '',
}

export default ModalToggleButton;
